import { Box, Grid } from "@mui/material";
import { ClaimBasedComponent } from "components/ClaimBasedComponent";
import NavCard from "components/NavCard";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import { ClaimResource } from "types/claimTypes";

const UsersPage = () => {
  const { formatMessage: t } = useIntl();
  const { usersListUrl, gradeExamsUrl, bulkEnrollmentUrl } = useGlobalContext();

  return (
    <Box my={4}>
      <Grid container spacing={4}>
        <ClaimBasedComponent requestedClaims={[ClaimResource.Users]}>
          <Grid item xs={12} sm={4}>
            <NavCard title={t({ id: "menubarUsers" })} url={usersListUrl()} />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.Users]}>
          <Grid item xs={12} sm={4}>
            <NavCard
              title={t({ id: "bulkEnrollment" })}
              url={bulkEnrollmentUrl()}
            />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.GradeUserExams]}>
          <Grid item xs={12} sm={4}>
            <NavCard
              title={t({ id: "menubarGradeUserExams" })}
              url={gradeExamsUrl()}
            />
          </Grid>
        </ClaimBasedComponent>
      </Grid>
    </Box>
  );
};

export default UsersPage;
